import React from 'react';
import { Modal, Button, Row, Col, Card, Avatar } from 'antd';
import '../Atoms/Nominee.css';


interface TeamDetailsModalProps {
    visible: boolean;
    onCancel: () => void;
    empData: any;
    teamData: any;
}

const getInitials = (name: string) => {
    const [firstName, lastName] = name.split(' ');
    return `${firstName.charAt(0)}${lastName.charAt(0)}`;
};

const TeamDetailsModal: React.FC<TeamDetailsModalProps> = ({ visible, onCancel, empData, teamData }) => {
    const teamMembers = teamData;
    const handleCancel = () => {
        onCancel();
    };

    return (
        <>
            <Modal
                title="Team Details"
                open={visible}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                ]}
                width={1000}
            >
                {empData ? (
                    <>
                        <Row gutter={[16, 16]}>
                            <Col span={12}><strong>Team</strong></Col>
                        </Row>
                        <Row gutter={[16, 16]}>
                            <Col span={12}>{empData.teamName}</Col>
                        </Row>

                        <Row style={{ marginTop: '20px' }}>
                            <Col span={24}><strong>Team Members</strong></Col>
                        </Row>

                        <Row gutter={[16, 16]}>
                            {teamMembers.map((member: any, index: any) => (
                                <Col key={index} span={8}>
                                    <Card>
                                        <Card.Meta
                                            avatar={
                                                <Avatar style={{ backgroundColor: '#87d068' }}>
                                                    {getInitials(member.name)}
                                                </Avatar>
                                            }
                                            title={member.name}
                                            description={member.title}
                                        />
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </>
                ) : (<div>Loading...</div>)}
            </Modal>
        </>
    );
};

export default TeamDetailsModal;
